var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89016 4.89016L6.52031 6.52031C7.92266 5.11772 9.85984 4.25 12 4.25C16.2706 4.25 19.7531 7.73516 19.75 12.0058C19.7469 16.2833 16.2783 19.75 12 19.75C10.0023 19.75 8.18119 18.9942 6.80694 17.7529C6.64716 17.6086 6.63966 17.3603 6.79187 17.2081L7.40869 16.5913C7.54925 16.4507 7.77597 16.4417 7.92434 16.574C9.00666 17.5389 10.4342 18.125 12 18.125C15.385 18.125 18.125 15.3856 18.125 12C18.125 8.61497 15.3856 5.875 12 5.875C10.3074 5.875 8.77634 6.56009 7.66831 7.66831L9.35981 9.35984C9.59606 9.59609 9.42875 10 9.09466 10H4.625C4.41791 10 4.25 9.83209 4.25 9.625V5.15534C4.25 4.82125 4.65394 4.65394 4.89016 4.89016Z",
    fill: "#20252F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.4644792fdba061f7b5678654d1f99fe0.svg";
export { ForwardRef as ReactComponent };